module.exports = __webpack_public_path__ + "img/margaret_obama.f5a68dcd.jpg";